document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector(".header");
    const burger = document.querySelector(".header__burger");
    const icon = burger.querySelector("img");

    if (!header || !burger || !icon) return;

    burger.addEventListener("click", () => {
        header.classList.toggle("open");

        // Toggle image source based on the presence of 'open' class
        icon.src = header.classList.contains("open") 
            ? "/img/header-icons/close.svg" 
            : "/img/header-icons/menu.svg";

        icon.alt = header.classList.contains("open") 
            ? "Close menu icon" 
            : "Menu icon";
    });

});


  
// Open sub-menu

document.addEventListener("DOMContentLoaded", () => {
    const navItems = document.querySelectorAll(".header__nav-item.has-children");
  
    navItems.forEach(item => {
      item.addEventListener("mouseenter", () => {
        item.classList.add("active");
        const dropdown = item.querySelector(".dropdown-menu");
  
        if (window.innerWidth >= 1000) {
          dropdown?.classList.add("open-menu");
        } else {
          dropdown?.classList.add("open-mobile");
        }
      });
  
      item.addEventListener("mouseleave", () => {
        item.classList.remove("active");
        const dropdown = item.querySelector(".dropdown-menu");
  
        if (window.innerWidth >= 1000) {
          dropdown?.classList.remove("open-menu");
        } else {
          dropdown?.classList.remove("open-mobile");
        }
      });

    });
  });








  
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.demo-slot').forEach(slot => {
    const btn   = slot.querySelector('#openSlotInfo');      // your button
    const panel = slot.querySelector('.slot-data');         // the info panel
    if (!btn || !panel) return;

    const OPEN_TEXT  = 'Open slot info';
    const CLOSE_TEXT = 'Close slot info';

    const setState = (open) => {
      panel.classList.toggle('slot-data--hidden', !open);
      const label = btn.querySelector('span');
      if (label) label.textContent = open ? CLOSE_TEXT : OPEN_TEXT;
      btn.classList.toggle('button--accent', open);
      btn.classList.toggle('button--tetriary', !open); // matches your class name
      btn.setAttribute('aria-expanded', String(open));
    };

    // click to toggle
    btn.addEventListener('click', () => {
      const isOpen = panel.classList.contains('slot-data--hidden') === false;
      setState(!isOpen);
    });

    // optional: keyboard support (Enter/Space)
    btn.setAttribute('role', 'button');
    btn.tabIndex = 0;
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        btn.click();
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header");
  const triggerHeight = 600;

  if (!header) return;

  const toggleHeaderBg = () => {
    if (window.scrollY > triggerHeight) {
      header.classList.add("header--scrolled");
    } else {
      header.classList.remove("header--scrolled");
    }
  };

  // Run on scroll
  window.addEventListener("scroll", toggleHeaderBg);

  // Run on page load (in case user reloads scrolled down)
  toggleHeaderBg();
});



